import React from 'react';
import PropTypes from 'prop-types';
import Input from 'common/components/elements/inputs/inputs';

const InputSection = ({
   value,
   name,
   limit,
   onChange,
   sectionName,
   ...props
}) => {
   const inputProps = props?.inputProps || {};
   return (
      <Input
         height='10'
         { ...inputProps }
         { ...props }
         value={ value }
         name={ `${ sectionName }_${ name }` }
         onChange={ (n, value) => {
            if(value.length > limit){
               return
            }
            onChange(name, value)
         } }
         description={ limit ? `${ value.length } of ${ limit } characters` : null }
      />
   )
}



InputSection.propTypes = {
   value: PropTypes.any,
   name: PropTypes.string,
   limit: PropTypes.number,
   onChange: PropTypes.func,
   inputProps: PropTypes.object,
   sectionName: PropTypes.string,
};
InputSection.defaultProps = {
   value: '',
   sectionName: '',
}

export default InputSection;
